module.exports = __webpack_public_path__ + "img/question-background-blur.12391fb3.svg";